import { createSelector } from "@reduxjs/toolkit";

export const getSubcategories = createSelector(
  (state) => state.subcategories.list,
  (list) => list
)
